




























import Vue from "vue"
import taskSchema from "../lib/task-schema"
import {TaskEditAction} from '../lib/story-utils';

export default Vue.extend({
  props: ['title', 'action'],

  data() {
    return {
      editor: {} as any,
      currType: ''
    }
  },

  mounted() {
    let action: TaskEditAction = this.action
    let schema = taskSchema[this.action.taskCategory]
    if (action.task.type && schema[action.task.type]) {
      this.currType = action.task.type
      this.renderJSONEditor(schema[action.task.type], JSON.parse(action.task.settings))
    }
  },

  computed: {
    supportedTypes(): string[] {
      return Object.keys(taskSchema[(<TaskEditAction>this.action).taskCategory])
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },

    save() {
      let newTask = {
        type: this.currType,
        settings: JSON.stringify(this.editor.getValue())
      }
      this.$emit('save', this.action, newTask)
    },

    onTypeChanged() {
      this.renderJSONEditor(taskSchema[(<TaskEditAction>this.action).taskCategory][this.currType])
    },

    renderJSONEditor(schema: any, startval?: any) {
      if (this.editor instanceof JSONEditor) {
        this.editor.destroy()
      }

      let ele = <HTMLElement>document.getElementById('editor')
      let options = {
        'theme': 'eventbus' as any,
        'disable_collapse': true,
        'startval': startval,
        /*'disable_edit_json': true,
        'disable_properties': true,*/
        'schema': schema || {},
        'display_required_only': true
      }
      this.editor = new JSONEditor(ele, options)
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TaskEditor.vue